// extracted by mini-css-extract-plugin
export default {"ai-marks":"style_ai-marks__lyg8Y"};